<script setup lang="ts">
import { BadgeColor } from './badge.constants';

type Props = {
  /** Text label rendered inside the badge, displayed uppercase. */
  label: string;
  /** Semantic status color, mapped to a container/on-container token pair. */
  color?: BadgeColor;
};

const props = withDefaults(defineProps<Props>(), {
  color: BadgeColor.INFO,
});

const colorClass: Record<BadgeColor, string> = {
  [BadgeColor.INFO]: 'bg-info-container text-on-info-container',
  [BadgeColor.NEUTRAL]: 'bg-neutral-container text-on-neutral-container',
  [BadgeColor.SUCCESS]: 'bg-success-container text-on-success-container',
  [BadgeColor.WARNING]: 'bg-warning-container text-on-warning-container',
  [BadgeColor.ERROR]: 'bg-error-container text-on-error-container',
};
</script>

<template>
  <span
    class="text-caption inline-flex w-fit items-center justify-center rounded-sm px-md py-sm text-center uppercase"
    :class="colorClass[props.color]"
  >
    {{ label }}
  </span>
</template>
